<lovers-popup 
  [exibir]="exibePopupLogout" 
  (onClose)="enviarParaHome()"
  [blockOverflow]="true"
  tamanho="pequeno" 
  id="modalLogout"
>
  <div class="popup__header">
    <p class="header__title">Alguém ai?</p>
  </div>
  <div class="popup__body">
    <div class="descricao">
      <p class="descricao__popup">
        Encerramos sua sessão por tempo expirado na nossa plataforma. Entre novamente na sua conta para retornar à sua navegação.
      </p>
    </div>
    <div class="modal__buttons">
      <button type="button" class="lovers-button" (click)="enviarParaHome()">
        Entrar novamente
      </button>
    </div>
  </div>
</lovers-popup>

<div class="container">
    <img class="img__fundo_desktop" src="./assets/images/backgrounds/fundo_embacado_desktop.png" alt="">
    <img class="img__fundo_mobile" src="./assets/images/backgrounds/fundo_embacado_mobile.png" alt="">
</div>